<template>
  <box-modal v-model="showModal" :title="$t('e_broad.set_emergency')" @on-visible-change="change" backgroundColor="rgba(21,54,70)">
    <Form :model="form" :label-width="130" ref="broadConfig">
      <!--   是否启用   -->
      <FormItem :label="'*'+$t('e_broad.enable')">
        <Select v-model="form.bEnable" :transfer="true">
          <Option v-for="(item,index) in enables" :value="item.value" :key="index">{{item.label}}</Option>
        </Select>
      </FormItem>
<!--      接入号-->
<FormItem :label="$t('broad_pstn')">
   <Select
    v-model="form.accessNum"
    :transfer="true"
    filterable
    :placeholder="$t('e_broad.selectOrInput')"
    allow-create
    clearable
    @on-create="handleCreateAccessNum" v-select-blur="handleBlur">
    <Option v-for="(item,index) in pstn" :value="item.value" :key="index">{{item.label}}</Option>
  </Select>


<!--  <Input v-model="form.accessNum"/>-->
</FormItem>


      <FormItem :label="$t('e_broad.access_pwd')">
        <Input v-model="form.accessNumPwd"/>
      </FormItem>
<!--      提示音-->
      <FormItem :label="$t('broad_tone')" :transfer="true">
        <Select v-model="form.promptTone" :transfer="true">
          <Option v-for="(item,index) in musics" :value="item.value" :key="index" v-show="!item.system || item.id==1">{{item.label}}</Option>
        </Select>
      </FormItem>
<!--      模式-->
      <FormItem :label="'*'+$t('broad_model')">
        <Select v-model="form.type" :transfer="true">
          <Option v-for="(item,index) in models" :value="item.value" :key="index">{{item.label}}</Option>
        </Select>
      </FormItem>
<!--      播放次数-->
      <FormItem :label="'*'+$t('broadPlayNum')" v-show="form.type==1">
        <Input v-model="form.playCount" type="number" />
      </FormItem>
<!--      文本内容-->
      <FormItem :label="'*'+$t('broadText')" v-show="form.type==1">
        <Input type="textarea" v-model="form.text"/>
      </FormItem>

      <FormItem :label="'*'+$t('musicPath')" v-show="form.type==2">
        <Select v-model="form.audioId">
          <Option v-for="(item,index) in musics" :value="item.value" :key="index" v-show="!item.system">{{item.label}}</Option>
        </Select>
      </FormItem>

      <FormItem :label="'*'+$t('broadTimeAndCom')" v-show="form.type==2">
        <Input v-model="form.lastTime" type="number"/>
      </FormItem>

    </Form>
    <div slot="footer">
      <Button type="primary" @click="save" :loading="loading">{{$t('sure')}}</Button>
      <Button type="primary" @click="cancel">{{$t('cancel')}}</Button>
    </div>
  </box-modal>
</template>
<script>
import {getNoUseAccess,getMusicList} from '@/api/data.js'
import {queryEmergencyBroad,saveEmergencyBroad} from '@/api/broadcast.js'

export default {
  name: 'BroadConfig',
  props:{
    show:false
  },
  data(){
    return {
      showModal: false,
      loading: false,
      pstn: [],
      musics: [],
      form: {
        enable: 0,
        accessNum: '',
        accessNumPwd: '',
        promptTone: '',
        type: 2,
        playCount: '',
        text: '',
        audioId: '',
        lastTime: ''
      }
    };
  },
  methods:{
    handleBlur(event) {
      const inputValue = event.target.value;
      if (inputValue && this.form.accessNum!==inputValue) {
        const exists = this.pstn.some(item => item.value === inputValue || item.label === inputValue);
        if (!exists) {
          this.handleCreateAccessNum(inputValue);
        } else {
          this.form.accessNum = inputValue;
        }
      }
    },
    handleCreateAccessNum(val) {

      // 创建新项（保持数据结构一致）
      const newItem = {
        value: val,
        label: val
      };

      // 避免重复添加
      const exists = this.pstn.some(item =>
        item.value === val || item.label === val
      );

      if (!exists) {
        this.pstn.push(newItem);
      }

      // 更新选中值
      this.form.accessNum = val;
    },
    resetFrom() {
      this.form = {
        enable: 0,
        accessNum: '',
        accessNumPwd: '',
        promptTone: '',
        type: 2,
        playCount: '',
        text: '',
        audioId: '',
        lastTime: ''
      }
    },
    change(val){
      this.$emit('modalChange', val)
    },
    loadSelect(){
      getNoUseAccess().then(res => {
        let response = res.data
        if (response.code == 200) {
          let arr = response.data
          this.pstn = []
          if (arr != null && arr.length > 0) {
            let nu = {
              value: '',
              label: this.$t('bpstnplaceHolder')
            }
            arr.unshift(nu)
            this.pstn = arr
          }
        }
      }).catch(err => reject(err))
      getMusicList().then(res=>{
        let response = res.data
        this.musics = []
        if (response.code == 200) {
          this.musics = response.data
          return
        }
        console.log('error', response)
      })
    },
    load() {
      queryEmergencyBroad().then(res=>{
        let response = res.data
        if (response.code == 200 && response.data.id) {
          let f = response.data
          this.form = {
            ...f,
            enable: f.enable,
            accessNum: f.accessNum,
            accessNumPwd: f.accessNumPwd,
            promptTone: f.promptTone+'',
            type: f.type,
            playCount: f.playTimes,
            text: f.text,
            audioId: f.audioId+'',
            lastTime: f.lastingTime
          }
        }
      })
    },
    save(){
      if (this.form.type == 1) {
        if (!this.form.playCount) {
          this.$Message.warning(this.$t('play_times_vali'))
          return
        }
        if (!this.form.text) {
          this.$Message.warning(this.$t('text_content_vali'))
          return
        }
      }else if (this.form.type == 2) {
        if (!this.form.audioId) {
          this.$Message.warning(this.$t('play_music_idvali'))
          return
        }
        if (!this.form.lastTime) {
          this.$Message.warning(this.$t('lasting_time_vali'))
          return
        }
      }
      const newForm = JSON.parse(JSON.stringify(this.form))
      newForm.enable = newForm.bEnable;
      this.loading = true
      try{
        saveEmergencyBroad(newForm).then(res=>{
          let response = res.data
          this.showModal = false
          if (response.code == 200) {
            this.$Message.success(this.$t('success'))
            this.loading = false
            return
          }
          this.$Message.error(response.msg)
          this.loading = false
        });
      }catch (e){
        this.$Message.error(this.$t('operate_fail'))
        this.loading = false
      }
    },
    cancel() {
      this.showModal = false
    },
  },
  computed:{
    enables() {
      return [
        {value: 0, label: this.$t('e_broad.stop')},
        {value: 1, label: this.$t('e_broad.enable')}
      ]
    },
    models(){
      return [
        {value: 1, label: this.$t('word_broad')},
        {value: 2, label: this.$t('music_broad')},
        {value: 4, label: this.$t('pro_broad')}
      ]
    }
  },
  watch:{
    show(val) {
      if (val) {
        this.resetFrom()
        this.loadSelect()
        this.load()
      }
      this.showModal = val;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/broadcast/broad-config.vue